import React from 'react'
import PropTypes from 'prop-types'

import AvatarImage from '../avatar-image'
import SettingsCard from '../../../components/Settings/SettingsCard'
import styles from './ProfileHeaderCard.module.scss'

/**
 * Avatar header for the settings page.
 */
export default function ProfileHeaderCard({ user, onAvatarChange }) {
  return (
    <SettingsCard>
      <div className={styles.header}>
        <div className={styles.avatar}>
          <AvatarImage
            imageUrl={
              user?.media_attachment?.thumbnail_url ??
              user?.media_attachment?.direct_upload_url ??
              '/images/default-user.png'
            }
            mediaAttachmentType="user"
            onChange={onAvatarChange}
          />
        </div>
      </div>
    </SettingsCard>
  )
}

ProfileHeaderCard.propTypes = {
  user: PropTypes.object,
  onAvatarChange: PropTypes.func.isRequired,
}
